import unescapedText from 'I18n/utils/unescapedText';
import { useCalendarStyles } from '../Calendar.styles';
import Chevron from '../../icons/Chevron';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderRow = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  style: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px'
  },
  children: children
});
const CalendarHeader = ({
  monthLabel,
  canGoPrev,
  canGoNext,
  isDisabled,
  onPrev,
  onNext
}) => {
  const {
    monthLabelStyle,
    navBtnStyle
  } = useCalendarStyles();
  return /*#__PURE__*/_jsxs(HeaderRow, {
    children: [/*#__PURE__*/_jsx("button", {
      "aria-label": unescapedText('interactiveCards.calendar.prevMonthAriaLabel'),
      style: navBtnStyle(!canGoPrev || isDisabled),
      disabled: !canGoPrev || isDisabled,
      onClick: onPrev,
      children: /*#__PURE__*/_jsx(Chevron, {
        direction: "left"
      })
    }), /*#__PURE__*/_jsx("span", {
      style: monthLabelStyle,
      children: monthLabel
    }), /*#__PURE__*/_jsx("button", {
      "aria-label": unescapedText('interactiveCards.calendar.nextMonthAriaLabel'),
      style: navBtnStyle(!canGoNext || isDisabled),
      disabled: !canGoNext || isDisabled,
      onClick: onNext,
      children: /*#__PURE__*/_jsx(Chevron, {
        direction: "right"
      })
    })]
  });
};
export default CalendarHeader;